<template>
    <v-dialog :value="value" width="720" @input="$emit('input', $event)">
        <div class="tp">
            <div class="tp-head">
                <div class="tp-title">{{ $t('unit.type.pick_title') }}</div>
                <!-- 型別不可逆，一定要先講 -->
                <div class="tp-note">{{ $t('unit.type.pick_note') }}</div>
            </div>

            <div v-for="group in groups" :key="group.key" class="tp-group">
                <div class="tp-group-title">{{ $t(`unit.type.${group.key}`) }}</div>
                <button v-for="t in group.types" :key="t" type="button" class="tp-item"
                    @click="$emit('pick', t)">
                    <span class="tp-icon" :class="`tp-icon--${group.tone}`">
                        <v-icon size="20" :color="group.tone === 'write' ? '#5c6bc0' : '#4b8f80'">
                            {{ icons[t] }}
                        </v-icon>
                    </span>
                    <span class="tp-body">
                        <span class="tp-name">{{ $t(`quest.main.${t}_frame`) }}</span>
                        <span class="tp-desc">{{ $t(`quest.edit.${t}_frame_description`) }}</span>
                    </span>
                </button>
            </div>

            <div class="tp-foot">
                <v-btn text class="normal-case" @click="$emit('input', false)">
                    {{ $t('button.cancel') }}
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
/// ⚠ 這裡的 key 是**資料庫的**型別 key，不是設計稿的。設計稿的 `feeling` 指的是
/// 我們的 `story`（情意），照抄會靜默存成錯誤的型別。對照表見
/// docs/plans/UnitTemplateEditor.web.steps.md。
/**
 * ⚠ 分組的依據是「學生要不要寫字」，而**只有 `feeling` 不用寫**。
 * `picture` 曾經被放在「不用打字」那一組，那是錯的——圖片畫格只是讓學生自己挑一張
 * 喜歡的照片上傳，照片之外**仍然要寫字**，所以它也有句型範例（2026-08-12 修正）。
 */
const GROUPS = [
    { key: 'group_tap', tone: 'tap', types: ['feeling'] },
    {
        key: 'group_write',
        tone: 'write',
        types: ['event', 'story', 'behavior', 'story_2', 'picture'],
    },
];

/// 設計稿用型別名的首字當圖示，但中文的「心情畫格」與「心情敘寫畫格」首字相同，
/// 而且首字取法在英日文沒有意義，所以改用 mdi。
const ICONS = {
    picture: 'mdi-image-outline',
    feeling: 'mdi-emoticon-happy-outline',
    event: 'mdi-calendar-text-outline',
    story: 'mdi-heart-outline',
    behavior: 'mdi-run-fast',
    story_2: 'mdi-emoticon-outline',
};

/** 新增畫格時的型別選擇對話框（設計稿 §8）。取代舊的 FrameTypeInfoDialog。 */
export default {
    name: 'FrameTypePicker',
    props: {
        value: { type: Boolean, default: false },
    },
    data() {
        return { groups: GROUPS, icons: ICONS };
    },
};
</script>

<style scoped>
.tp {
    background: #fff;
    border-radius: 8px;
    padding: 22px 24px 12px;
}

.tp-head {
    margin-bottom: 18px;
}

.tp-title {
    font-size: 19px;
    font-weight: 500;
    color: #212121;
}

.tp-note {
    font-size: 13px;
    color: #757575;
    margin-top: 4px;
}

.tp-group + .tp-group {
    margin-top: 18px;
}

.tp-group-title {
    font-size: 12px;
    color: #757575;
    letter-spacing: 1px;
    margin-bottom: 8px;
}

.tp-item {
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    text-align: left;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 14px 16px;
    cursor: pointer;
}

.tp-item + .tp-item {
    margin-top: 8px;
}

.tp-item:hover {
    border-color: #1e88e5;
    background: #f3f8fe;
}

.tp-icon {
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tp-icon--write {
    background: #eef4fb;
}

.tp-icon--tap {
    background: #eaf3f1;
}

.tp-body {
    flex: 1;
    min-width: 0;
}

.tp-name {
    display: block;
    font-size: 15px;
    font-weight: 500;
    color: #212121;
}

.tp-desc {
    display: block;
    font-size: 13px;
    color: #757575;
    line-height: 1.6;
}

.tp-foot {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
}

@media (max-width: 767px) {
    .tp-desc {
        display: none;
    }
}
</style>
